<template>
  <div class="monac-box" :style="{display: display}">
    <div class="monac-head clearfix">
      <div class="monac-lenguage">
        <span>编译语言：</span>
        <select class="select-lenguage" @change="changLenguage">
          <option value="python">Python</option>
          <option value="cpp">C++</option>
        </select>
      </div>
      <div class="icon-setting" @click="settingClick">
        <img src="../../assets/icon-setting.svg">
      </div>
    </div>

    <settingDialog
        :dialog-state="settingState"
        @event-dialog-close="eventDialogClose"
        @event-setting="eventSetting"></settingDialog>

    <codeEditor
        :console-state="consoleState"
        :monaco-options="monacoOptions"
        ref="refCode"></codeEditor>

    <consolePanel
        :console-state="consoleState"
        :run-result="runResult"
        ref="refConsole"
        @event-console-close="consoleClose"></consolePanel>

    <div class="monac-foot clearfix">
      <span class="action-btn text" @click="consoleClick">{{consoleTxt}}</span>
      <div class="button-group">
        <button type="button" class="btn action-btn debug" @click="debugClick">调试</button>
        <button type="button" class="btn action-btn btn-primary" @click="releaseClick">提交检测</button>
      </div>
    </div>
  </div>
</template>

<script>
import codeEditor from "@/components/common/codeEditor";
import consolePanel from "@/components/panel/consolePanel";
import settingDialog from "@/components/panel/settingDialog";
import serviceApi from "@/utils/serviceApi";
import utils from "@/utils/utils";
import bus from "@/utils/eventBus";

export default {
  name: "monacPage",
  props:{
    isShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      settingState: false,
      consoleState: false,
      monacoOptions: {
        value: "",
        readOnly: false, // 是否只读
        language: "python", // 语言类型
        theme: "vs-dark", // 编辑器主题
        minimap: {
          enabled: false, // 不要小地图
        },
      },
      runResult:{
        msg: '暂无执行结果',
        records:[
        //     {
        //   recordId: "1",
        //   MemorySize: "23kb",
        //   runTime: "23ms",
        //   runState: false,
        //   runResult: '结果错误'
        // }
        ]
      }
    };
  },
  computed:{
    display:function (){
      if(this.isShow){
        return "block"
      }else{
        return "none";
      }
    },
    consoleTxt:function (){
      if(this.consoleState){
        return '关闭控制台'
      }else{
        return '打开控制台'
      }
    }
  },
  mounted() {
    this.init()
  },
  methods:{
    init(){
      serviceApi.loadQueCode(
          {language: this.monacoOptions.language},
          (resultData)=>{
            this.setCodeValue(decodeURIComponent(resultData.codeContext));
          })
    },
    eventDialogClose:function (){
      this.actionWin = 'USECASE'
      this.settingState = false
    },
    settingClick:function (){
      this.settingState = true
    },
     // setting:{themeVal: '',fontVal: '',tabVal: '' }
    eventSetting: function (setting){
      this.$refs.refCode.setTheme(setting.themeVal)
      this.$refs.refCode.setTabSize(setting.tabVal)
      this.$refs.refCode.setFontSize(setting.fontVal)
    },
    consoleClick: function (){
      this.consoleState = !this.consoleState
    },
    consoleClose: function (){
      this.consoleState = false
    },
    changLenguage: function (e){
      let language = e.target.value
      this.monacoOptions.language = language
      this.setCodelanguage(language)
      this.init();
    },
    getUsecase(){
      return this.$refs.refConsole.getContext()
    },

    getCodeValue(){
      return this.$refs.refCode.getVal();
    },
    setCodeValue(value){
      this.$refs.refCode.setVal(value);
    },
    setCodelanguage(lenguage){
      this.$refs.refCode.setLanguage(lenguage)
    },
    editorDispose(){
      this.$refs.refCode.editorDispose()
    },
    editorFormat(){
      this.$refs.refCode.runFormat()
    },
    //调试
    debugClick: function (){
      let language = this.monacoOptions.language;
      let codeValue= encodeURIComponent(this.getCodeValue());
      let usecase= this.getUsecase();
      this.consoleState = true;
      this.$refs.refConsole.resultClick();
      this.runResult.msg = "正在调测中...";
      serviceApi.updateQueCode(
          {
            codeId: utils.guid(),
            language: language,
            usecase: usecase,
            codeContext: codeValue,
            state: 'debug'
          },
          (resultData)=>{
            if(resultData[0].resultState == 'true'){
              this.runResult.msg = "运行正确"
            }else{
              if (resultData[0].errmsg == ""){
                this.runResult.msg = resultData[0].result
              }else{
                this.runResult.msg = resultData[0].errmsg
              }
            }
            this.runResult.records=[];
            this.consoleState = true;
            this.$refs.refConsole.resultClick();
            console.log(resultData)
          })
    },
    //提交
    releaseClick: function (){
      let language = this.monacoOptions.language;
      let codeValue= encodeURIComponent(this.getCodeValue());
      let usecase= this.getUsecase();
      this.consoleState = true;
      this.$refs.refConsole.resultClick();
      this.runResult.msg = "正在检测中...";
      this.runResult.records = [];
      serviceApi.updateQueCode(
          {
            codeId: utils.guid(),
            language: language,
            usecase: usecase,
            codeContext: codeValue,
            state: 'release'
          },
          (resultData)=>{
            let flag = true
            let records = []
            for(let i = 0, len = resultData.length; i < len; i ++){
              if(resultData[i].resultState.toUpperCase() == "FALSE"){
                flag = false;
              }
              let record = {
                    recordId: i + 1,
                    MemorySize: resultData[i].memorysize + "kb",
                    runTime: resultData[i].runtime + "sm",
                    runState: resultData[i].resultState.toUpperCase() == "TRUE",
                    runResult: resultData[i].resultState.toUpperCase() == "TRUE" ?"正确":"结果错误",
                  }
              records.push(record);
            }
            this.runResult.msg = ""
            this.runResult.records = records;
            this.consoleState = true;
            this.$refs.refConsole.resultClick();
            if (flag){
              this.releaseTopic()
            }
          })
    },

    releaseTopic: function (){
      let language = this.monacoOptions.language;
      let codeValue= this.getCodeValue();
      let codeVal = "\n\n\n" +
                "```" +
                language + "\n" +
                codeValue + "\n" +
                "```"
      bus.emit("openNewTopic", codeVal)
    }

  },
  components:{
    codeEditor,
    consolePanel,
    settingDialog
  }
}
</script>

<style scoped>
.monac-box{
  position: relative;
  height: 100vh;
  background-color:#28343C;
  color:#ffffff
}
.monac-head{
  position:relative;
  height:50px;
  line-height:50px;
  padding-left:10px;
}
.monac-lenguage{
  float: left;
}
.icon-setting{
  float: right;
  margin-right: 10px;
  padding-top: 7px;
  cursor: pointer;
}
.select-lenguage{
  font-size:16px;
  background:#28343C;
  border-color: hsla(0,0%,100%,.15);
  color: #fff;
  height:30px;
  border-radius: 5px;
}
.select-lenguage option{
  padding-top: 20px;
}

.monac-foot{
  width: 100%;
  position:relative;
  height:50px;
  line-height:50px;
  padding-left:10px;
  background-color:#28343C;
  color:#ffffff;
  box-sizing: border-box;
}
.monac-foot span{
  display: inline-block;
  float: left;
  box-sizing: border-box;
}
.button-group{
  display: inline-block;
  float: right;
  margin-right: 20px;
}

.btn {
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    /*color: #212529;*/
    display: inline-block;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.3;
    padding: 0.275rem 0.75rem;
    text-align: center;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    vertical-align: middle;
    cursor: pointer;
  margin-left: 10px;
}

.action-btn{
    background-color: #0080f6;
    border-color: #0080f6;
    color: #fff;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
}

.action-btn:hover {
    filter: brightness(120%);
}

.action-btn.text
{
    display:block;
    background-color: transparent;
    color: #fff;
    cursor: pointer;
    width: 150px;
    float:left;
}

.action-btn.btn-primary {
    background-color: #2e7eee;
    border-color: #2e7eee;
    color: #fff;
}

.action-btn.debug{
    background: transparent;
    border: 1px solid #e49030;
    color: #e49030;
}

</style>
